import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { CurrencyToken } from '@sleed/bizcommerce-api';
import { currenciesApi } from '~/lib/api/client';
import { formToToken, type CurrencyFormValues } from '~/lib/schemas/currency';

export const currencyKeys = {
	all: ['currencies'] as const,
	list: () => [...currencyKeys.all, 'list'] as const
};

export function useCurrenciesList() {
	return useQuery<CurrencyToken[]>({
		queryKey: currencyKeys.list(),
		queryFn: async () => (await currenciesApi.getAll()).data.items ?? []
	});
}

export function useCurrencyMutations() {
	const qc = useQueryClient();
	const invalidate = () => qc.invalidateQueries({ queryKey: currencyKeys.list() });
	const create = useMutation({
		mutationFn: async (form: CurrencyFormValues) => (await currenciesApi.insert(formToToken(form))).data,
		onSuccess: invalidate
	});
	const update = useMutation({
		mutationFn: async (form: CurrencyFormValues) => (await currenciesApi.update(formToToken(form))).data,
		onSuccess: invalidate
	});
	const remove = useMutation({ mutationFn: async (id: number) => (await currenciesApi.remove(id)).data, onSuccess: invalidate });
	return { create, update, remove };
}
